import { getRouteApi, Link } from "@tanstack/react-router";
import { ROUTES } from "@/app/routes";
import { LogoLockup } from "@/shared/components/brand/logo-mark";
import { Button } from "@/shared/components/ui/button";

const route = getRouteApi(ROUTES.auth.authError.id);

const COPY: Record<string, { title: string; body: string }> = {
  "invalid-or-expired": {
    title: "This link is no longer valid",
    body: "Request a fresh magic link, they expire after 15 minutes and can only be used once.",
  },
  csrf: {
    title: "Sign-in didn't complete",
    body: "Something went wrong while verifying the sign-in request. Please try again.",
  },
  default: {
    title: "Sign-in didn't complete",
    body: "Try again, or request a new magic link.",
  },
};

export function AuthErrorRoute() {
  const { reason } = route.useSearch();
  const copy = COPY[reason ?? "default"] ?? COPY.default;
  if (!copy) return null;
  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center gap-4 px-6 py-12 text-center">
      <LogoLockup className="w-fit" />
      <h1 className="font-display text-2xl font-semibold tracking-tight">{copy.title}</h1>
      <p className="text-sm text-text-secondary">{copy.body}</p>
      <Button asChild>
        <Link to="/signup" search={{}}>
          Request a new link
        </Link>
      </Button>
    </div>
  );
}
